import { createFileRoute, Link } from "@tanstack/react-router";
import { Arrow } from "@/components/icons";
import { routeHead } from "@/components/seo";
import { pageMeta, site, process as steps } from "@/content";
import { Aurora, Grain, Particles, TiltCard, spotlightPointer } from "@/components/motion";

const ROUTE = "/how-we-work";
export const Route = createFileRoute("/how-we-work")({
  head: () => routeHead(ROUTE),
  component: Page,
});

function Page() {
  const p = pageMeta(ROUTE)!;
  return (
    <div className="bg-background text-foreground">
      <section className="border-b border-line">
        <div className="mx-auto max-w-4xl px-6 py-20">
          <h1 className="hero-enter mt-4 font-serif text-4xl leading-[1.1] text-ink sm:text-5xl">
            {p.h1}
          </h1>
          <p className="hero-enter-delay mt-6 text-lg leading-relaxed text-ink/80">
            {p.description}
          </p>
        </div>
      </section>
      <section className="horizon-field--light border-b border-line">
        <div className="mx-auto max-w-4xl px-6 py-16">
          <ol className="stagger space-y-6">
            {steps.map((s) => (
              <li key={s.step}>
                <TiltCard className="card-premium grid gap-4 p-6 sm:grid-cols-[80px_1fr] sm:items-start">
                  <span className="font-serif text-4xl text-teal">
                    {String(s.step).padStart(2, "0")}
                  </span>
                  <div>
                    <h2 className="font-serif text-xl text-ink">{s.title}</h2>
                    <p className="mt-2 leading-relaxed text-ink/80">{s.description}</p>
                  </div>
                </TiltCard>
              </li>
            ))}
          </ol>
        </div>
      </section>
      <section onMouseMove={spotlightPointer} className="spotlight horizon-field text-white">
        <Aurora />
        <Grain />
        <Particles count={10} />
        <div className="relative z-10 mx-auto max-w-4xl px-6 py-16 text-center">
          <h2 className="reveal text-shimmer font-serif text-2xl sm:text-3xl">
            Start with a Strategic Finance Review.
          </h2>
          <div className="reveal mt-6">
            <Link to={site.primaryCta.href} className="btn-on-dark">
              {site.primaryCta.label}
              <Arrow className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
